

























































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import GroupingPackageDetail from '@/store/entities/grouping-packages/grouping-package-detail';
import GroupingPackage from '@/store/entities/grouping-packages/grouping-package';

@Component({
    
})
export default class ViewGroupingPackage extends AbpBase{
    namespace = 'deliveryPackageGroup';
    code: string = "";
    grouping : GroupingPackage = new GroupingPackage();
    packages : GroupingPackageDetail[] = new Array<GroupingPackageDetail>();

  get loading(){
      return this.$store.state.deliveryPackageGroup.loading;
  }

    async getGroupongPackage(code){
      await this.$store
        .dispatch({
            type:`${this.namespace}/viewGroupingPackage`,
            data: { code : this.code}
        })
        .then(res => {
          this.grouping = res;
          this.packages = res.packages;
        });
    }

    onBack(){
        this.$router.push({name: 'grouping-package'});
    }

    onPrintShippingLabel(){
          var url = `/#/shipping-label-group/${this.grouping.groupingPackageCode}`;
          window.open(url, "_blank");  
    }

    packageColumns = [
      {
          title:Util.L('Order'),
          align: "center",
          slot: "order",
      },{
          title:Util.L('Package'),
          key:'packageCode'
      },{
          title:Util.L('SoCode'),
          key:'soCode'
      },{
          title:Util.L('ExternalCode'),
          key:'externalCode'
      },{
          title:Util.L('CreatorUserName'),
          key:'creatorUserName'
      },{
          title:Util.L('CreationTime'),
          key:'creationTime',
          render:(h:any,params:any)=>{
              return h("span", Util.toViewDateString(params.row.creationTime));
          }
      }
    ];

    async created(){
      this.code = this.$root.$router.currentRoute.params.code;
      await this.getGroupongPackage(this.code);
    }
}
